<template>
  <view
    class="card-container"
    wx:class="{{{'worry-free': serviceType === 2 && isAboutToDepart}}}"
    id="right-card-{{serviceType}}"
  >
    <view
      class="rights-select-card"
      wx:class="{{{'no-bottom': serviceType === 2 && isAboutToDepart}}}"
    >
      <view class="rights-select-card-desc" wx:class="{{{'less-top': couponAmountDesc}}}">
        <view class="rights-select-card-desc-left">
          <view
            class="rights-select-card-desc-price"
            wx:if="{{ Number.isFinite(seatPrice) && seatPrice >= 0}}"
          >
            <view class="amount">
              <view class="signal"> ¥ </view>
              {{ seatPrice }}
            </view>
          </view>
          <view class="allowance" wx:if="{{couponAmountDesc}}">{{ couponAmountDesc }}</view>
        </view>
        <view
          class="rights-select-card-desc-hightlight"
          wx:if="{{!is12306Right && extrudeTips.title}}"
        >
          <view class="rights-select-card-desc-hightlight-top" style="color: {{serviceIconColor}}">
            <image class="icon" src="{{hightlightIcon}}" />
            {{ extrudeTips.title }}
          </view>
          <view wx:if="{{extrudeTips.subhead}}" class="rights-select-card-desc-hightlight-bottom">{{
            extrudeTips.subhead
          }}</view>
        </view>
        <view
          class="rights-select-card-btn"
          wx:class="{{{'scramble': isScramble || isPreScramble}}}"
          bindtap="handleClick"
          ><view class="btn-text" wx:class="{{{'remaining': remainingText}}}">{{ btnText }}</view>
          <view class="remain-text" wx:if="{{remainingText}}">{{ remainingText }}</view>
        </view>
      </view>
      <view
        class="rights-select-card-benefits"
        wx:if="{{serviceTipArr.length || serviceSubTitle}}"
        bindtap="openRightsDescDrawer"
      >
        <spring-icon
          wx:if="{{!is12306Right}}"
          h="16"
          w="8"
          color="{{serviceIconColor}}"
          name="right-thin-arrow"
          externClass="arrow-icon"
        />
        <view wx:if="{{!is12306Right}}" class="mask" style="background: {{serviceMaskColor}}">
        </view>
        <view class="divider" wx:class="{{{'gray' : is12306Right}}}" />
        <view class="rights-select-card-benefits-desc" style="color: {{serviceTextColor}}">
          <view
            class="rights-select-card-benefits-desc-title"
            wx:if="{{!is12306Right}}"
            wx:style="{{serviceTitleColor}}"
          >
            {{ serviceTitle }}
          </view>
          <view
            class="rights-select-card-benefits-desc-price"
            wx:if="{{ Number.isFinite(serviceFee) && serviceFee >= 0 && !is12306Right}}"
            style="color: {{serviceIconColor}}"
            ><view class="unit">+</view>¥{{ serviceFee }}</view
          >
          <view wx:if="{{!is12306Right}}" class="tip" wx:for="{{serviceTipArr}}" wx:key="index">
            <spring-icon
              color="{{serviceIconColor}}"
              h="15"
              w="16"
              name="marketing-check-mark"
              externClass="check-icon"
            />
            <view class="text">
              {{ item }}
            </view>
          </view>
          <view class="sub-title" wx:if="{{is12306Right}}">{{ serviceSubTitle }}</view>
        </view>
      </view>
    </view>
  </view>
</template>

<script>
  import { mpx, createComponent } from '@didi/es-mpx-creator'
  import { getFinalPrice } from '@/utils/money'
  import store from '@/store'
  import { trackEvent } from '@/common/track'
  import { getURL } from '@didi/webx-js'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import { innerRouter, pagePath } from '@/common/jump'
  import { createObserver } from '@/common/observer'
  import dayjs from 'dayjs'

  createComponent({
    props: {
      serviceInfo: {
        type: Object,
        value: () => {}
      },
      seatInfo: {
        type: Array,
        value: () => []
      }
    },
    data() {
      return {
        observer: null
      }
    },
    watch: {
      serviceInfo: {
        immediate: true,
        deep: true,
        handler(newVal, oldVal) {
          this.$nextTick(() => {
            if (Number.isInteger(newVal.fee)) {
              this.observer && this.observer.closeObserver()
              this.observer = createObserver({
                element: `right-card-${this.serviceType}`,
                key: 'yks_train_detailpage_tag_sw',
                name: '迎客松-火车票-车次详情页-商品tag-曝光',
                params: this.trackParams,
                continued: true,
                threshold: 0.75
              })
            }
          })
        }
      }
    },
    computed: {
      ...store.mapState({
        isTransfer: 'train.isTransfer',
        selectRightInfo: 'train.selectRightInfo',
        isNight: 'train.trainInfo.is_ticket_period',
        hasLogin: 'login12306.is12306Login',
        baichuanTrainPrivacy: 'common.baichuanTrainPrivacy',
        trainInfo: 'train.trainInfo',
        selectSeatInfo: 'train.selectSeatInfo'
      }),
      ...store.mapGetters({
        curTransferIndex: 'train.curTransferIndex'
      }),
      trackParams() {
        const trackMap = {
          1: 'nologin',
          2: 'noworries',
          3: 'normal'
        }
        return {
          tagtype: this.serviceType === 2 && this.isAboutToDepart ? 'special' : 'null',
          servicetype: trackMap[this.serviceType]
        }
      },
      serviceTipArr() {
        return this.serviceInfo.tips ?? []
      },
      serviceSubTitle() {
        return this.serviceInfo.miniTitle ?? ''
      },
      serviceFee() {
        let fee
        if (!this.isTransfer) fee = this.serviceInfo.fee
        else {
          fee = this.seatInfo.reduce((total, item) => {
            return (
              total +
              (this.isNight
                ? item?.service_info?.offlineService?.fee ?? 0
                : item?.service_info?.serviceInfoList[0]?.fee ?? 0)
            )
          }, 0)
        }
        return getFinalPrice(fee)
      },
      servicePriceAndName() {
        return this.serviceInfo.title && this.serviceInfo.fee
          ? `+￥${getFinalPrice(this.serviceFee)}${this.serviceInfo.title}`
          : this.serviceInfo?.title || ''
      },
      seatPrice() {
        const totalPrice =
          this.seatInfo?.reduce((acc, cur) => acc + Number(cur.ticket_price ?? 0), 0) || 0
        const price = getFinalPrice(totalPrice) - this.couponAmount
        return price
      },
      // 直达是否有具体票数且小于阈值
      remainingText() {
        const isAboutToSellOut =
          !this.isTransfer &&
          this.seatInfo?.some(({ ticket_num }) => {
            const ticketNum = Number(ticket_num?.match(/\d+/)?.[0] || 0)
            return ticketNum > 0 && ticketNum <= (this.trainInfo?.ticket_left_urgent_num || 0)
          })
        return isAboutToSellOut ? `剩${this.seatInfo?.[0]?.ticket_num}` : ''
      },
      serviceType() {
        return this.serviceInfo.type
      },
      serviceMaskColor() {
        let color = ''
        switch (this.serviceType) {
          case 2:
            color =
              'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 32%, rgba(255, 255, 255, 0) 81%, #FFFFFF 100%), linear-gradient(180deg, #FCEFDD 7%, rgba(253, 244, 230, 0.25) 97%)'
            break
          case 1:
            color =
              'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0) 84%, #FFFFFF 97%), linear-gradient(180deg, rgba(51, 143, 255, 0.1) 0%, rgba(51, 143, 255, 0) 100%)'
            break
          default:
            color = '#FFF'
        }
        return color
      },
      serviceIconColor() {
        let color = ''
        switch (this.serviceType) {
          case 1:
            color = '#338FFF'
            break
          case 2:
            color = '#773D16'
            break
          default:
            color = '#FFF'
        }
        return color
      },
      serviceTextColor() {
        let color = ''
        switch (this.serviceType) {
          case 1:
            color = '#666'
            break
          case 2:
            color = '#773D16'
            break
          default:
            color = '#999'
        }
        return color
      },
      serviceTitleColor() {
        let style = {
          '-webkit-background-clip': 'text',
          '-webkit-text-fill-color': 'transparent',
          'background-clip': 'text'
        }
        let color = ''
        switch (this.serviceType) {
          case 1:
            color = 'linear-gradient(325deg, #338FFF 92%, #82BAFF 155%)'
            break
          case 2:
            color = 'linear-gradient(131deg, #954916 0%, #773D16 41%)'
            break
          default:
            color = ''
        }
        return {
          background: color,
          ...style
        }
      },
      isScramble() {
        return this.seatInfo.every((item) => item && item.ticket_num === '无票')
      },
      isPreScramble() {
        return this.trainInfo.pre_scrambl_flag === 1
      },
      btnText() {
        return this.isScramble || this.isPreScramble || this.remainingText ? '抢' : '订'
      },
      couponInfoContainer() {
        return this.isTransfer
          ? this.serviceInfo.union_all_price?.[this.curTransferIndex] || {}
          : this.serviceInfo
      },
      couponAmount() {
        return !this.showCouponAmount
          ? 0
          : getFinalPrice(this.couponInfoContainer?.deduction_amount ?? 0)
      },
      couponAmountDesc() {
        // 直接用权益券
        return !this.showCouponAmount ? '' : this.couponInfoContainer?.discount_desc || ''
      },
      is12306Right() {
        return this.serviceInfo.type === 3
      },
      showCouponAmount() {
        return this.couponInfoContainer?.coupon_show === true
      },
      serviceTitle() {
        return this.serviceInfo?.title || ''
      },
      hightlightIcon() {
        let icon = ''
        switch (this.serviceType) {
          case 1:
            icon = 'https://ut-static.udache.com/webx/sfc/HpIgujz-fivTocCVTcTGd.png'
            break
          case 2:
            icon = 'https://ut-static.udache.com/webx/sfc/1b7BV9FoNyP9YFstcGedo.png'
            break
          default:
            icon = ''
        }
        return icon
      },
      isAboutToDepart() {
        const now = dayjs()
        const startTime = dayjs(this.trainInfo.start_time)
        const time48HoursBefore = startTime.subtract(192, 'hour')
        return now.isBefore(startTime) && now.isAfter(time48HoursBefore)
      },
      extrudeTips() {
        // return this.serviceInfo.extrude_tips || {}
        return this.serviceInfo.extrude_tips_map?.seat_detail || {}
      }
    },
    methods: {
      ...store.mapMutations({
        setSelectRightInfo: 'train.setSelectRightInfo',
        setSelectRightInfoType: 'train.setSelectRightInfoType',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource',
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setExpectTicket: 'train.setExpectTicket',
        setShowLoginDrawer: 'login12306.setShowLoginDrawer',
        setRightCardType: 'makeOrder.setRightCardType'
      }),
      ...store.mapActions({
        getCurrentUserReverse: 'login12306.getCurrentUserReverse'
      }),
      handleClick(isNotPopup = true) {
        // 选择权益时记得清除多买少买坐席信息， 下单时注意清除权益信息
        this.setExpectTicket({})
        if (this.isTransfer) {
          const newRightInfo = this.seatInfo.map((item) => {
            return this.isNight
              ? item?.service_info?.offlineService ?? {}
              : item?.service_info?.serviceInfoList[0] ?? {}
          })
          this.setSelectRightInfo(newRightInfo)
        } else {
          let newRightInfo
          const is12306 = this.serviceInfo.type === 3
          if (this.isNight && !this.isScramble && is12306) {
            newRightInfo = [this.seatInfo[0]?.service_info?.offlineService ?? {}]
          } else {
            newRightInfo = this.selectRightInfo
            newRightInfo[0] = this.serviceInfo
            // 未登录且选了非12306购票，买线下票
            if (!this.hasLogin && newRightInfo[0].type !== 3) {
              this.setMakeOrderLoginType(1)
            } else if (newRightInfo[0].type === 3) {
              this.setMakeOrderLoginType(0)
            }
          }
          // 记录坐席页选择的权益卡类型 （夜间购票 && 非抢票 && 普通购票 会切换记录成便携购票）
          const useType = newRightInfo[0]?.type
          this.setSelectRightInfoType(useType)
          const added_service_map = isNotPopup
            ? {
                1: 'detail_page__nologin',
                2: 'detail_page__noworries',
                3: ''
              }
            : {
                1: '', // 'detail_page_float__nologin',
                2: 'detail_page_float__noworries',
                3: ''
              }
          this.setAddedServiceSource([added_service_map[useType]])
          this.setSelectRightInfo(newRightInfo)
        }
        trackEvent('right_select', '排查-权益选择', {
          right: this.selectRightInfo
        })
        isNotPopup &&
          trackEvent('yks_train_detailpage_tag_ck', '迎客松-火车票-车次详情页-商品tag-点击', {
            ...this.trackParams,
            button: 'subscribe'
          })
        if (this.baichuanTrainPrivacy?.title) {
          return this.triggerEvent('showBaichuanPrivacyDrawer')
        }
        const { from = '' } = this.$mpxRoute.query
        const startTimeLog = new Date().getTime()
        if (this.isScramble || this.isPreScramble) {
          return this.getCurrentUserReverse({ init: true })
            .then((res) => {
              const { data, success, message, code } = res || {}
              const endTimeLog = new Date().getTime()
              const deltaTimeLog = endTimeLog - startTimeLog
              trackEvent('userteam_train_reverse_time', 'UT-火车票-预定校验-接口耗时', {
                deltaTime: deltaTimeLog
              })
              if (success) {
                if (code === '0') {
                  if (getURL()?.indexOf('make-order') === -1) return
                  const { is_login } = data || {}
                  if (!is_login) {
                    this.setShowLoginDrawer(true)
                  } else {
                    this.setMakeOrderLoginType(0)
                    innerRouter.push(pagePath().MAKEORDERBACKUP, {
                      from: this.from,
                      order_type: 'scramble'
                    })
                  }
                } else {
                  mpx.showToast({
                    title: message || LOAD_FAIL_CONTENT, //提示的内容,
                    icon: 'error' //图标,
                  })
                }
                //12306默认返回1 航天根据状态返回 0 或者 1
              } else {
                mpx.showToast({
                  title: LOAD_FAIL_CONTENT, //提示的内容,
                  icon: 'success' //图标,
                })
              }
            })
            .finally(() => {
              mpx.hideLoading()
            })
        }
        this.triggerEvent('click')
      },
      openRightsDescDrawer() {
        if (this.serviceType === 2 && this.isAboutToDepart) {
          this.setRightCardType('special')
        } else {
          this.setRightCardType('null')
        }
        trackEvent('yks_train_detailpage_tag_ck', '迎客松-火车票-车次详情页-商品tag-点击', {
          ...this.trackParams,
          button: 'show'
        })
        this.triggerEvent('openRightsDescDrawer', this.serviceType)
      }
    }
  })
</script>

<style scoped lang="stylus">
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/zFeca_fdUIuxJfpXUFGY5_ZaoZiGongFangYuanHeiTi-2-Medium.otf')
  .worry-free
    padding 36px 2px 2px 2px
    box-sizing border-box
    background-image url('https://ut-static.udache.com/webx/sfc/PDidbSnP44ohqJJlQhtAH.png')
    background-size 100% auto
    background-repeat no-repeat
    background-position top center
    margin-bottom 10px
    border-radius 10px
  .rights-select-card
    width 100%
    display flex
    flex-direction column
    background-color #fff
    border-radius 8px
    margin-bottom 10px
    &.no-bottom
      margin-bottom 0
    &-desc
      display flex
      justify-content space-between
      padding 18px 16px
      padding-left 15px
      align-items center
      box-sizing border-box
      &.less-top
        padding-top 15px
      &-left
        display flex
        flex-direction column
        align-items flex-start
        .subtitle
          margin-top 4px
          font-family PingFangSC-Regular
          font-weight 400
          font-size 11px
          line-height 12px
          color #999
        .allowance
          margin-top 4px
          position relative
          box-sizing border-box
          padding 2px
          font-family PingFangSC-Regular
          font-weight 400
          line-height 10px
          font-size 10px
          color #FF6400
          &::after
            position absolute
            height 200%
            width 200%
            border-radius 8px
            border 1px solid #FFBC91
            content ''
            transform scale(0.5)
            top 0
            left 0
            transform-origin 0 0
      &-hightlight
        display flex
        flex-direction column
        &-top
          display flex
          align-items center
          font-family PingFangSC-Medium
          font-weight 500
          font-size 13px
          line-height 12px
          .icon
            height 14px
            width 14px
            margin-right 4px
        &-bottom
          font-size 11px
          line-height 12px
          color #999
          font-family PingFangSC-Regular
          font-weight 400
          margin-top 8px
      &-price
        display flex
        align-items center
        .amount
          display flex
          align-items baseline
          font-family Barlow Semi Condensed
          font-size 28px
          line-height 28px
          color #FF6400
          .signal
            font-family PingFangSC-Semibold
            font-size 16px
            font-weight 600
            line-height 16px
            margin-right 2px
      &-service
        font-family PingFangSC-Regular
        font-weight 400
        font-size 11px
        line-height 16px
        margin-bottom 1px
        margin-left 5px
        color #666
        align-self flex-end
    &-btn
      box-sizing border-box
      border-radius 10px
      height 44px
      width 44px
      display flex
      flex-direction column
      align-items center
      font-family PingFangSC-Medium
      font-weight 500
      font-size 18px
      line-height 18px
      color #fff
      background #FF6400
      .btn-text
        margin-top 13px
        &.remaining
          margin-top 6px
      .remain-text
        width 40px
        height 14px
        display flex
        align-items center
        justify-content center
        font-family PingFangSC-Medium
        font-weight 500
        font-size 10px
        background #fff
        border-radius 0 0 8px 8px
        color #FF6400
        margin-top 4px
      &.scramble
        background #FF4129
    &-benefits
      width 100%
      position relative
      display flex
      align-items flex-start
      overflow hidden
      .mask
        position absolute
        z-index 1
        content ''
        top 0
        left 0
        height 100%
        width 100%
        border-radius 0 0 8px 8px
        background linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0) 79%, #FFFFFF 100%), linear-gradient(180deg, rgba(51, 143, 255, 0.1) 0%, rgba(51, 143, 255, 0) 100%)
      .divider
        position absolute
        width 100%
        height 1px
        opacity 0.8
        background-image linear-gradient(90deg, rgba(51, 143, 255, 0.2) 0%, rgba(51, 143, 255, 0.08) 100%)
        left 0
        top 0
        transform scaleY(0.5) translateY(-100%)
        &.gray
          background #eee
          opacity 1
      &-img
        z-index 20
        height 18px
        margin-top 12px
        margin-left 16px
      .arrow-icon
        z-index 20
        position absolute
        bottom 5px
        right 12px
        transform translate(100%, -50%)
      &-desc
        position relative
        z-index 2
        width calc(100% - 36px)
        display flex
        overflow-x auto
        padding 8px 0px
        margin-left 16px
        box-sizing border-box
        border-radius 0 0 8px 8px
        &-title
          line-height 12px
          flex-shrink 0
          margin-right 4px
          font-size 12px
          font-family MFYuanHei
        &-price
          flex-shrink 0
          display flex
          align-items baseline
          font-family PingFangSC-Medium
          font-weight 500
          line-height 12px
          font-size 11px
          margin-right 16px
          opacity 0.9
          .unit
            display flex
            align-items flex-end
            height 12px
            line-height 1
        .tip
          position relative
          flex-shrink 0
          display flex
          flex-wrap nowrap
          align-items center
          border-radius 0 0 8px 8px
          &:not(:last-child)
            margin-right 8px
          .check-icon
            margin-right 3px
          .text
            font-size 11px
            line-height 12px
            font-family PingFangSC-Regular
            font-weight 400
        .sub-title
          font-size 11px
          line-height 12px
          font-family PingFangSC-Regular
          font-weight 400
          color #999
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'spring-icon': '@didi/spring-icon'
    }
  }
</script>